import { Component, Input, OnInit, inject } from '@angular/core';
import { first } from 'rxjs';
import { PUNCHOUT_USER_EXTRA_KEY, PunchoutCustomerConfig } from '../../../../models/punchout';
import { PunchoutConfigAdminService } from '../../../../services/punchout/punchout-config-admin.service';
import { User } from '../../../../state/auth/types';

@Component({
  selector: 'lib-user-details-punchout',
  templateUrl: './user-details-punchout.component.html',
  styleUrls: ['./user-details-punchout.component.scss'],
  standalone: false
})
export class UserDetailsPunchoutComponent implements OnInit {
  protected adminService = inject(PunchoutConfigAdminService);

  @Input() currentUser!: User;

  availableConfigs: PunchoutCustomerConfig[] = [];
  selectedConfigId: string | null = null;
  loading = false;

  ngOnInit(): void {
    this.selectedConfigId = (this.currentUser?.extra?.[PUNCHOUT_USER_EXTRA_KEY] as string) ?? null;
    this.loading = true;
    this.adminService
      .list()
      .pipe(first())
      .subscribe({
        next: configs => {
          this.availableConfigs = configs ?? [];
          this.loading = false;
        },
        error: () => {
          this.availableConfigs = [];
          this.loading = false;
        }
      });
  }

  apply(): void {
    if (!this.currentUser) {
      return;
    }
    if (!this.currentUser.extra) {
      this.currentUser.extra = {};
    }
    if (this.selectedConfigId) {
      this.currentUser.extra[PUNCHOUT_USER_EXTRA_KEY] = this.selectedConfigId;
    } else {
      delete this.currentUser.extra[PUNCHOUT_USER_EXTRA_KEY];
    }
  }
}
